export default __webpack_public_path__ + "static/media/logo_error.43a646ce.png";